import { createFileRoute, redirect, useRouter } from '@tanstack/react-router';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '@/stores/auth.store';
import { BusinessUnitBrandingEditor } from '@/components/organisms/business-units/BusinessUnitBrandingEditor';
import { useBusinessUnit } from '@/hooks/scheduler/useBusinessUnits';

export const Route = createFileRoute('/_dashboard/dashboard/settings/business-units/$id')({
  beforeLoad: () => {
    const { permissions } = useAuthStore.getState();
    if (permissions.length > 0 && !permissions.includes('jobs:view')) {
      throw redirect({ to: '/dashboard/home' });
    }
  },
  component: BusinessUnitBrandingPage,
});

function BusinessUnitBrandingPage() {
  const { id } = Route.useParams();
  const router = useRouter();
  const { data: businessUnit, isLoading, isError } = useBusinessUnit(id);

  if (isLoading) {
    return (
      <div className="flex h-64 items-center justify-center text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
      </div>
    );
  }
  if (isError || !businessUnit) {
    return (
      <div className="mx-auto max-w-2xl px-4 py-16 text-center text-sm text-muted-foreground">
        This business unit could not be loaded.
      </div>
    );
  }

  return (
    <BusinessUnitBrandingEditor businessUnit={businessUnit} onBack={() => router.history.back()} />
  );
}
